import React from "react";
import myPlanTokens from "../MyPlan.tokens";

interface IconProps {
  /** Square edge length; defaults to the design's 15px row icon. */
  size?: string;
  color?: string;
}

const baseProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** Row "delete card" glyph — matches the design's stroke paths exactly. */
export const TrashIcon: React.FC<IconProps> = ({
  size = myPlanTokens.size.rowIcon,
  color = myPlanTokens.color.muted,
}) => (
  <svg {...baseProps} stroke={color} aria-hidden="true" focusable="false" style={{ width: size, height: size, display: "block" }}>
    <path d="M3 6h18" />
    <path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
  </svg>
);

/** Invoice "download receipt" glyph. */
export const DownloadIcon: React.FC<IconProps> = ({
  size = myPlanTokens.size.rowIcon,
  color = "currentColor",
}) => (
  <svg {...baseProps} stroke={color} aria-hidden="true" focusable="false" style={{ width: size, height: size, display: "block" }}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="M7 10l5 5 5-5" />
    <path d="M12 15V3" />
  </svg>
);
